import {createSelector} from 'reselect';
import {getSystem} from './store';
import {
    getGeneratedLocale,
    getGeneratedLocaleFormatted,
    getGeneratedLocaleFull
} from '../utils/localeUtils';

const getBrandName = createSelector(
    [getSystem],
    (system) => {
        return system.humanReadableSiteName || '';
    }
);

const getHumanReadableBrandName = createSelector(
    [getSystem],
    (system) => {
        return system.humanReadableBrandName || '';
    }
);

const getBrandId = createSelector(
    [getSystem],
    (system) => {
        return system.brandId || '';
    }
);

const getBrowserName = createSelector(
    [getSystem],
    (system) => {
        return system.browserName;
    }
);

const getDeviceSize = createSelector(
    [getSystem],
    (system) => {
        return system.deviceSize;
    }
);

const getWidth = createSelector(
    [getSystem],
    (system) => system.width
);

const getHeight = createSelector(
    [getSystem],
    (system) => system.height
);

const getIsDesktop = createSelector(
    [getSystem],
    (system) => {
        return system.isDesktop;
    }
);

const getIsMobile = createSelector(
    [getSystem],
    (system) => {
        return system.isMobile;
    }
);

const getIsTablet = createSelector(
    [getSystem],
    (system) => {
        return system.isTablet;
    }
);

const getCurrency = createSelector(
    [getSystem],
    (system) => system.currency
);

const getLocale = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocale(system.locale);
    }
);

const getLocaleFull = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocaleFull(system.locale);
    }
);

const getLocaleJS = createSelector(
    [getSystem],
    (system) => {
        return getGeneratedLocaleFormatted(system.locale);
    }
);

const getReviewPageSize = createSelector(
    [getSystem],
    (system) => {
        return system.reviewPageSize;
    }
);

const getSiteName = createSelector(
    [getSystem],
    (system) => {
        return system.siteName;
    }
);

const getSystemClientSideRendered = createSelector(
    [getSystem],
    (system) => {
        return system.clientSideRendered;
    }
);

const getBathroomStrategy = createSelector(
    [getSystem],
    (system) => {
        return system.bathroomStrategy;
    }
);

const getHostName = createSelector(
    [getSystem],
    (system) => {
        return system.hostName;
    }
);

const getIsInternalUser = createSelector(
    [getSystem],
    (system) => {
        return system.isInternalUser;
    }
);

const getBaseUrlPath = createSelector(
    [getSystem],
    (system) => {
        return system.baseUrlPath;
    }
);

const getLanguageNativeName = createSelector(
    [getSystem],
    (system) => {
        return system.languageNativeName;
    }
);

const getLanguageName = createSelector(
    [getSystem],
    (system) => {
        return system.languageName;
    }
);

const getEnvironment = createSelector(
    [getSystem],
    (system) => {
        return system.environment;
    }
);

const getHavId = createSelector(
    [getSystem],
    (system) => {
        return system.havId || '';
    }
);

const getGaiaId = createSelector(
    [getSystem],
    (system) => {
        return system.gaiaId || '';
    }
);

const getIsMetric = createSelector(
    [getSystem],
    (system) => {
        return system.isMetric;
    }
);

const getCancellationPolicyUrl = createSelector(
    [getSystem],
    (system) => {
        return system.cancellationPolicyUrl;
    }
);

const getReportFraudUrl = createSelector(
    [getSystem],
    (system) => {
        return system.reportFraudUrl;
    }
);

const getPrivacyPolicyUrl = createSelector(
    [getSystem],
    (system) => {
        return system.privacyPolicyUrl;
    }
);

const getTermsAndConditionsUrl = createSelector(
    [getSystem],
    (system) => {
        return system.termsAndConditionsUrl;
    }
);

const getMarketingOptInType = createSelector(
    [getSystem],
    (system) => {
        return system.marketingOptInType.other;
    }
);

export {
    getBrandName,
    getHumanReadableBrandName,
    getBrandId,
    getBrowserName,
    getDeviceSize,
    getWidth,
    getHeight,
    getHostName,
    getIsDesktop,
    getIsMobile,
    getIsTablet,
    getCurrency,
    getLocale,
    getLocaleFull,
    getLocaleJS,
    getReviewPageSize,
    getSiteName,
    getSystemClientSideRendered,
    getBathroomStrategy,
    getBaseUrlPath,
    getLanguageNativeName,
    getLanguageName,
    getEnvironment,
    getIsInternalUser,
    getHavId,
    getGaiaId,
    getIsMetric,
    getCancellationPolicyUrl,
    getReportFraudUrl,
    getPrivacyPolicyUrl,
    getTermsAndConditionsUrl,
    getMarketingOptInType
};
